'use strict';
/* eslint no-console: 0 */

'use es6';

// BasePatternFactory
// ---
// Standardize pattern structure and provide free invariant checking.

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var REQUIRED_PROPERTIES_CHECK = function REQUIRED_PROPERTIES_CHECK(name, validator) {
  if (!name || typeof name !== 'string') {
    console.error('Required "name" string property not provider for pattern. Provided: ' + (typeof name === 'undefined' ? 'undefined' : _typeof(name)));
  }

  if (!validator || typeof validator !== 'function') {
    console.error('Required "validator" callback not provider for "' + name + ' pattern". Provided: ' + (typeof validator === 'undefined' ? 'undefined' : _typeof(validator)));
  }
};

var TYPE_INVARIANT = function TYPE_INVARIANT(name, method, input, requiredInputType) {
  var actualInputType = typeof input === 'undefined' ? 'undefined' : _typeof(input);
  if (actualInputType !== requiredInputType) {
    console.error('Invariant error in ' + name + ' pattern. Pattern.' + method + '() method can only be passed a ' + requiredInputType + '. Provided: ' + actualInputType);
    return true;
  }
};

exports.default = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$name = _ref.name,
      name = _ref$name === undefined ? '' : _ref$name,
      _ref$inputType = _ref.inputType,
      inputType = _ref$inputType === undefined ? 'string' : _ref$inputType,
      _ref$validator = _ref.validator,
      validator = _ref$validator === undefined ? null : _ref$validator,
      _ref$matcher = _ref.matcher,
      matcher = _ref$matcher === undefined ? null : _ref$matcher;

  REQUIRED_PROPERTIES_CHECK(name, validator);

  var Pattern = {
    name: name,

    inputType: inputType,

    test: function test(input) {
      if (inputType && TYPE_INVARIANT(name, 'test', input, inputType)) {
        return false;
      }

      return validator(input);
    }
  };

  if (matcher && typeof matcher === 'function') {
    Pattern.match = function (input) {
      if (inputType && TYPE_INVARIANT(name, 'match', input, inputType)) {
        return false;
      }

      return matcher(input);
    };
  }

  return Pattern;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/PatternValidationJS/static-1.38/js/lib/BasePatternFactory.js
// module id = 125
// module chunks = 0 1